<script lang="ts">
	import { onMount } from "svelte";

	interface Props {
		targetDate: Date;
		running: boolean;
		onComplete: () => void;
	}

	const { running = true, targetDate, onComplete }: Props = $props();
	let remainingTime = $state(calculateTimeLeft());
	let intervalId: ReturnType<typeof setInterval>;

	function calculateTimeLeft() {
		const difference = +targetDate - +new Date();
		let timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0, expired: false };
		if (difference > 0) {
			timeLeft = {
				days: Math.floor(difference / (1000 * 60 * 60 * 24)),
				hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
				minutes: Math.floor((difference / 1000 / 60) % 60),
				seconds: Math.floor((difference / 1000) % 60),
				expired: false,
			};
		} else {
			timeLeft.expired = true;
		}
		return timeLeft;
	}

	onMount(() => {
		if (running) {
			intervalId = setInterval(() => {
				remainingTime = calculateTimeLeft();
				if (remainingTime.expired) {
					clearInterval(intervalId);
					onComplete?.();
				}
			}, 1000);
		}
		return () => {
			if (intervalId) {
				clearInterval(intervalId);
			}
		};
	});
</script>

<div class="grid w-full grid-cols-4 items-center justify-center divide-x divide-white/15 rounded-full bg-(--poll-countdown-background-color) p-9 text-(--poll-countdown-text-color)">
	<div class="flex flex-col items-center justify-center gap-2">
		<span class="text-2xl font-bold">{String(remainingTime.days).padStart(2, "0")}</span>
		<span class="text-xs uppercase">Days</span>
	</div>
	<div class="flex flex-col items-center justify-center gap-2">
		<span class="text-2xl font-bold">{String(remainingTime.hours).padStart(2, "0")}</span>
		<span class="text-xs uppercase">Hours</span>
	</div>
	<div class="flex flex-col items-center justify-center gap-2">
		<span class="text-2xl font-bold">{String(remainingTime.minutes).padStart(2, "0")}</span>
		<span class="text-xs uppercase">Mins</span>
	</div>
	<div class="flex flex-col items-center justify-center gap-2">
		<span class="text-2xl font-bold">{String(remainingTime.seconds).padStart(2, "0")}</span>
		<span class="text-xs uppercase">Secs</span>
	</div>
</div>
